import React, { lazy } from 'react';
import SuspenseWrapper from '@/components/SuspenseWrapper.tsx';

const Resume = lazy(() => import('@/pages/Resume'));
const PrivacyPolicy = lazy(() => import('@/pages/Legal/PrivacyPolicy'));
const FAQs = lazy(() => import('@/pages/Legal/FAQs'));
const Complaints = lazy(() => import('@/pages/Legal/Complaints'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const Status = lazy(() => import('@/pages/Status'));
const Lenders = lazy(() => import('@/pages/Lenders'));

const suspenseWrap = (children: React.ReactNode) => (
  <SuspenseWrapper fallbackClassName="min-h-screen w-full">{children}</SuspenseWrapper>
);

const ANCILARY_PAGES: Record<string, { path: string; component: React.ReactNode; title: string }> =
  {
    RESUME: {
      path: '/resume',
      component: suspenseWrap(<Resume />),
      title: 'Resume',
    },
    PRIVACY_POLICY: {
      path: '/privacy-policy',
      component: suspenseWrap(<PrivacyPolicy />),
      title: 'Privacy Policy',
    },
    COMPLAINTS: {
      path: '/complaints',
      component: suspenseWrap(<Complaints />),
      title: 'Complaints',
    },
    FAQs: {
      path: '/faqs',
      component: suspenseWrap(<FAQs />),
      title: 'FAQs',
    },
    FAQs_ALIAS: {
      path: '/frequently-asked-questions',
      component: suspenseWrap(<FAQs />),
      title: 'FAQs',
    },
    NOT_FOUND: {
      path: '/404',
      component: suspenseWrap(<NotFound />),
      title: 'Not Found',
    },
    STATUS_PAGE: {
      path: '/status',
      component: suspenseWrap(<Status />),
      title: 'Status',
    },
    LENDERS: {
      path: '/lenders',
      component: suspenseWrap(<Lenders />),
      title: 'Lenders',
    },
  };

export default ANCILARY_PAGES;
